import { render, staticRenderFns } from "./GestionarPropuestasCompras.vue?vue&type=template&id=18616846&scoped=true"
import script from "./GestionarPropuestasCompras.vue?vue&type=script&lang=js"
export * from "./GestionarPropuestasCompras.vue?vue&type=script&lang=js"
import style0 from "./GestionarPropuestasCompras.vue?vue&type=style&index=0&id=18616846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18616846",
  null
  
)

export default component.exports